import { QuizQuestion as BaseQuizQuestion } from '@skooldio/skooldio-classroom-components';
import styled from 'styled-components';

import { get as getTheme } from 'Components/Base/constants';

const QuizQuestion = styled(BaseQuizQuestion)`
  & img {
    max-width: 100%;
  }

  /* NOTE: Fixed MathJax overflow issues on mobile devices (width ≤ 768px) 
  - https://skooldio.atlassian.net/browse/ANY-1674
  - https://skooldio.atlassian.net/browse/ANY-1681
  */
  @media (max-width: ${getTheme('breakpoints.1')}) {
    & p {
      overflow-x: auto;
      padding: 8px 0px 16px 0px;
    }
  }
`;

export default QuizQuestion;
